import React from 'react';
import { PROVIDER_STATUS } from '../../lib/traceability';

export function AssignmentDetails({ assignment, eventName, clientView = false }) {
  if (clientView) return <dl className="text-sm space-y-1">
    <div><dt>Fecha del servicio</dt><dd>{assignment.service_date || 'Sin registrar'}</dd></div>
    <div><dt>Estatus</dt><dd>{PROVIDER_STATUS[assignment.status] || 'Sin registrar'}</dd></div>
  </dl>;
  return <dl className="text-sm space-y-1">
    <div><dt>Evento</dt><dd>{eventName || assignment.event_name || assignment.event?.name || 'Evento asignado'}</dd></div>
    <div><dt>Solicitante</dt><dd>{assignment.requester_name || 'Sin registrar'}</dd></div>
    <div><dt>Empresa organizadora</dt><dd>{assignment.organizer_company || 'Sin registrar'}</dd></div>
    <div><dt>Fecha del servicio</dt><dd>{assignment.service_date || 'Sin registrar'}</dd></div>
    <div><dt>Horario</dt><dd>{assignment.service_time_start || '—'} – {assignment.service_time_end || '—'}</dd></div>
    <div><dt>Unidades</dt><dd>{assignment.units ?? '—'}</dd></div>
    <div><dt>Observaciones</dt><dd>{assignment.observations || 'Sin observaciones'}</dd></div>
    <div><dt>Estatus</dt><dd>{PROVIDER_STATUS[assignment.status] || 'Sin registrar'}</dd></div>
  </dl>;
}

// ADM-R5: una API antigua no debe disparar una consulta por cada evento.
export default function ProviderAssignments({ provider, clientView = false }) {
  if (!Array.isArray(provider.events)) return <p>Asignaciones disponibles al actualizar el servidor.</p>;
  return <section><h4>{clientView ? 'Servicios asignados' : 'Eventos asignados'}</h4>
    {!provider.events.length && <p>Sin asignaciones en los eventos a los que tienes acceso.</p>}
    {provider.events.map(item => <AssignmentDetails key={item.id} assignment={item} clientView={clientView} />)}
  </section>;
}
